import * as moment from "moment/moment";

export function determineIsTimeExpired(dateTime: any): boolean {
  const now = moment();
  const givenTime = moment(dateTime);
  const differenceInHours = now.diff(givenTime, "hours");

  return differenceInHours > 24;
}

export function timeUntil24HoursExpires(dateTime: string): string {
  const now = moment();
  const givenTime = moment(dateTime);
  const elapsedHours = now.diff(givenTime, "hours", true);
  const remainingTime = 24 - elapsedHours;
  const remainingHours = Math.floor(remainingTime); // Whole hours
  const remainingMinutes = Math.round((remainingTime - remainingHours) * 60); // Remaining minutes

  return `${remainingHours}h ${remainingMinutes}m`;
}
